@if (ready()) {
  <nav class="navigation">
    <a
      class="navigation_link"
      (click)="onBackButtonClicked()"
      title="Evident Connect">
      <evc-icon
        icon="chevron-left"
        size="lg" />
      <div class="logo-container">
        <img
          class="nav-imagotype"
          src="/assets/logos/evident-connect-imagotype.svg"
          alt="Evident Connect" />
      </div>
    </a>

    <evc-select
      class="navigation__language"
      [options]="languagesOptions()"
      [value]="currentLanguage() ?? null"
      (change)="setLanguage($event)" />
  </nav>

  <router-outlet />

  <div class="layers">
    <div class="layers__toasts">
      @if (toast(); as toast) {
        <evc-toast class="toast" />
      }
    </div>
  </div>
}
